export default __webpack_public_path__ + "img/checked-circle-v2.1c5c9fb8.svg";